/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';

import routes from '../libs/routes';
import images from "../libs/images";

import { loadingStart, loadingEnd } from "../redux/loadingSlice";
import { open, close } from '../redux/popupSlice';
import { setLang } from '../redux/langSlice';

import { setData as setEtcData } from '../redux/etcSlice';
import Popup01 from "../pages/popup/Popup01"
import Cookies from 'js-cookie';
import { persistor } from '../redux/store';
import * as API from "../libs/service";

import {
    logIn,
    logOut,
    gpsUpdate,
    configData,
    setData,
    aroundData,
    menuClose,
    mainReset,
    searchClose,
    pickerClose,
} from "../redux/usersSlice";

import { useTranslation } from 'react-i18next';
import { setCountry, setLanguage } from '../redux/locationSlice';

export default function Header() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const { topBanner } = useSelector(s => s.etcReducer);
    const { mbData } = useSelector((s) => s.usersReducer);
    const lang = useSelector(state => state.langReducer.lang);

    const [headerBtnHover1, setHeaderBtnHover1] = useState(false);
    const [headerBtnHover2, setHeaderBtnHover2] = useState(false);
    const [headerBtnHover3, setHeaderBtnHover3] = useState(false);
    const [headerBtnHover4, setHeaderBtnHover4] = useState(false);
    const [headerBtnHover5, setHeaderBtnHover5] = useState(false);
    const [headerBtnHover6, setHeaderBtnHover6] = useState(false);

    const [mobileMenu, setMobileMenu] = useState(false);
    const [mobileBtnHover1, setMobileBtnHover1] = useState(false);
    const [mobileBtnHover2, setMobileBtnHover2] = useState(false);
    const [mobileBtnHover3, setMobileBtnHover3] = useState(false);
    const [mobileBtnHover4, setMobileBtnHover4] = useState(false);
    const [mobileBtnHover5, setMobileBtnHover5] = useState(false);
    const [mobileBtnHover6, setMobileBtnHover6] = useState(false);

    const headerTabOn1 = ["/Support", "/Inquiry"];
    const isActive1 = headerTabOn1.includes(location.pathname);

    const headerTabOn2 = ["/Price"];
    const isActive2 = headerTabOn2.includes(location.pathname);

    const headerTabOn3 = ["/Education"];
    const isActive3 = headerTabOn3.includes(location.pathname);

    const headerTabOn4 = [""];
    const isActive4 = headerTabOn4.includes(location.pathname);

    const [headerProfile, setHeaderProfile] = useState(false);

    const [langDrop, setLangDrop] = useState(false);
    const language_sample = ['한국어', 'English']

    const logOutnavi = [
        "/Profile",
        "/ProfileCoupon",
        "/ProfileEdit",
        "/BuyList",
        "/CardList",
        "/PayList",
        "/PlusMember",
        "/PlusAdmin",
        "/InquiryList",
        "/CancelSub"
    ]; // 해당 페이지에서 로그아웃하면 메인으로
    const logOutActive = logOutnavi.includes(location.pathname);

    // 위치정보 시작
    const { country, language } = useSelector((state) => state.locationReducer);

    const requestGeolocation = async () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const { latitude, longitude } = position.coords;
                console.log({ latitude, longitude });
                setCoord({ latitude, longitude });
            }, (error) => {
                console.error('Error getting geolocation:', error);
                console.error('Error getting geolocation:', mbData, mbData?.countryCode);
                if(mbData?.countryCode){
                    console.log('??????????????');
                    dispatch(setCountry(mbData?.countryCode === 'KR' ? 'KR' : 'US'));
                    dispatch(setLanguage(mbData?.countryCode === 'KR' ? 'ko' : 'en'));
                } else {
                    dispatch(setCountry('err'));
                    dispatch(setLanguage('err'));
                }
            });
        } else {
            console.error('Geolocation is not supported by this browser.');
        }
    }

    const [coord, setCoord] = useState(null);

    useEffect(() => {
        console.log(country);
        //if (country.isDefault) {
            requestGeolocation();
        //}
    }, [location, mbData]);

    useEffect(() => {
        const getCountry = async () => {
            const api = 'AIzaSyCLEShV6IiLOIeBOX87h57lMIep2L2i12Q';
            const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${coord?.latitude},${coord?.longitude}&key=${api}`;

            try {
                const result = await fetch(url);
                const data = await result.json();

                if (data && data.results && data.results.length > 0) {
                    const countryComponent = data.results[0].address_components.find(component =>
                        component.types.includes("country")
                    );
                    if (countryComponent) {
                        dispatch(setCountry(countryComponent.short_name));
                        if (countryComponent.short_name === 'KR') {
                            dispatch(setLanguage('ko'));
                        } else {
                            dispatch(setLanguage('en'));
                        }
                    } else {
                        console.log("Country code not found in the first result.");
                    }
                } else {
                    console.log("No results found.");
                }
            } catch (error) {
                console.error('Error getting geolocation:', error);
                console.error('Error getting geolocation:', mbData);
                if(mbData?.countryCode){
                    dispatch(setCountry(mbData?.countryCode === 'KR' ? 'KR' : 'US'));
                    dispatch(setLanguage(mbData?.countryCode === 'KR' ? 'ko' : 'en'));
                } else {
                    dispatch(setCountry('err'));
                    dispatch(setLanguage('err'));
                }
            }
        };
        //if (coord) {
            getCountry();
        //}
    }, coord);

    // 위치정보 끝

    useEffect(() => {
        localStorage.removeItem('language');
        const handleResize = () => {
            const width = window.innerWidth;
            if (width > 900) {
                setMobileMenu(false)
            }
        };

        handleResize();

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    /* useEffect(() => {
        console.log('0이면 한, 1이면 영', lang);

    }, [lang]); */

    /* useEffect(() => {
        if(mbData) {
            console.log('로그인 함', mbData);
        } else {
            console.log('로그인 안함', mbData);
        }

    }, [mbData]); */

    /* useEffect(() => {
        dispatch(logOut());
    }, []); */

    const logoutPopup = () => {
        dispatch(open({
            component:
                <Popup01
                    max_width={'300px'}
                    text1={lang === 0 ? '로그아웃 하시겠습니까?' : 'Are you sure you want to Logout?'}
                    button={lang === 0 ? '확인' : 'OK'}
                    buttonCancel={lang === 0 ? '취소' : 'Cancel'}
                    setFunc={() => {
                        logoutFunc()
                    }}
                />
        }));
    }

    const logoutFunc = async () => {
        dispatch(loadingStart());

        try {
            // gtag('event', 'download_hub_header', {
            //     'event_category': 'engagement',
            //     'event_label': lang === 0 ? '다운로드 Hub(Header)' : 'Download Hub(Header)'
            // });

            await API.post('auth/logout', {}, true);
        } catch (err) {
            console.error(err);
        }

        dispatch(logOut());
        persistor.purge();
        if (logOutActive) {
            navigate(routes.main)
        }
        dispatch(loadingEnd());
    }

    const ChangeLang = (type) => {
        dispatch(loadingStart())
        setTimeout(() => {
            dispatch(setLang(type));
            dispatch(loadingEnd())
        }, 1000);
    }

    return (
        <>
            <div className={`header_main_box ${mobileMenu ? 'mobile_show' : ''}`}>
                <div className="header_btn_box">
                    <div>
                        <img
                            src={require("../assets/icon/logo_col.svg").default}
                            onClick={() => {
                                navigate(routes.main)
                                window.location.reload();
                            }}
                        />

                        <div className={`header_btn_group pc ${lang === 0 ? 'ko' : 'eng'}`}>
                            <div
                                className={`header_btn ${headerBtnHover1 ? 'on' : ''}`}
                                onMouseOver={() => {
                                    setHeaderBtnHover1(true)
                                }}
                                onMouseOut={() => {
                                    setHeaderBtnHover1(false)
                                }}
                                style={{
                                    minWidth: lang === 1 ? '103px' : '',
                                    fontSize: lang === 1 ? '18px' : ''
                                }}
                            >
                                {lang === 0 ? '기능' : 'Features'}
                                {headerBtnHover1 ?
                                    <img src={require("../assets/icon/down_arr_on.svg").default} />
                                    :
                                    <img src={require("../assets/icon/down_arr_off.svg").default} />
                                }

                                {headerBtnHover1 &&
                                    <div
                                        className="header_btn_drop"
                                        onMouseOut={() => {
                                            setHeaderBtnHover1(false)
                                        }}
                                        style={{
                                            minWidth: lang === 1 ? '359px' : ''
                                        }}
                                    >
                                        <p
                                            className=""
                                            onClick={() => {
                                                navigate(routes.Modeling);
                                            }}
                                        >
                                            {lang === 0 ? '스케치업 스타일 모델링' : 'SketchUp-Style Modeling'}
                                        </p>
                                        <p
                                            className=""
                                            onClick={() => {
                                                navigate(routes.PModeling);
                                            }}
                                        >
                                            {lang === 0 ? '폴리곤 모델링' : 'Polygon Modeling'}
                                        </p>
                                        <p
                                            className=""
                                            onClick={() => {
                                                navigate(routes.UV_Editing)
                                            }}
                                        >
                                            {lang === 0 ? 'UV 에디팅' : 'UV Editing'}
                                        </p>
                                        <p
                                            className=""
                                            onClick={() => {
                                                navigate(routes.Painting)
                                            }}
                                        >
                                            {lang === 0 ? '페인팅' : 'Painting'}
                                        </p>
                                        <p
                                            className=""
                                            onClick={() => {
                                                navigate(routes.Rigging)
                                            }}
                                        >
                                            {lang === 0 ? '리깅과 스키닝' : 'Rigging and Skinning'}
                                        </p>
                                        <p
                                            className=""
                                            onClick={() => {
                                                navigate(routes.Intergration)
                                            }}
                                        >
                                            {lang === 0 ? '유니티 통합환경' : 'Unity Intergration'}
                                        </p>
                                        <p
                                            className=""
                                            onClick={() => {
                                                navigate(routes.Extension)
                                            }}
                                        >
                                            {lang === 0 ? 'Pro 확장 기능' : 'Pro Extension Features'}
                                        </p>
                                        <p
                                            className=""
                                            onClick={() => {
                                                navigate(routes.AI)
                                            }}
                                        >
                                            {lang === 0 ? '생성형 AI 활용' : 'Generative AI Utilization'}
                                        </p>
                                        <p
                                            className="last"
                                            onClick={() => {
                                                navigate(routes.Library)
                                            }}
                                        >
                                            {lang === 0 ? '템플릿 라이브러리' : 'Template Library'}
                                        </p>
                                    </div>
                                }
                            </div>

                            <div
                                className={`header_btn ${headerBtnHover2 ? 'on' : ''}`}
                                onMouseOver={() => {
                                    setHeaderBtnHover2(true)
                                }}
                                onMouseOut={() => {
                                    setHeaderBtnHover2(false)
                                }}
                                style={{
                                    minWidth: lang === 1 ? '99px' : '',
                                    fontSize: lang === 1 ? '18px' : ''
                                }}
                            >
                                {lang === 0 ? '활용 분야' : 'Use Cases'}
                                {headerBtnHover2 ?
                                    <img src={require("../assets/icon/down_arr_on.svg").default} />
                                    :
                                    <img src={require("../assets/icon/down_arr_off.svg").default} />
                                }
                                {headerBtnHover2 &&
                                    <div
                                        className="header_btn_drop two"
                                        onMouseOut={() => {
                                            setHeaderBtnHover1(false)
                                        }}
                                        style={{
                                            minWidth: lang === 1 ? '267px' : ''
                                        }}
                                    >
                                        <p
                                            className=""
                                            onClick={() => {
                                                navigate(routes.GameDev);
                                            }}
                                        >
                                            {lang === 0 ? '게임 개발' : 'Game Development'}
                                        </p>
                                        <p
                                            className=""
                                            onClick={() => {
                                                navigate(routes.Metaverse);
                                            }}
                                        >
                                            {lang === 0 ? '메타버스 제작' : 'Metaverse Creation'}
                                        </p>
                                        {/* <p 
                                            className=""
                                            onClick={() => {
                                                navigate(routes.Indust);
                                            }}
                                        >
                                            {lang === 0 ? '산업 디자인' : 'Industrial Design'}
                                        </p> */}
                                        <p
                                            className="last"
                                            onClick={() => {
                                                navigate(routes.Edu);
                                            }}
                                        >
                                            {lang === 0 ? '교육' : 'Education'}
                                        </p>
                                    </div>
                                }
                            </div>

                            <div
                                className={`header_btn ${headerBtnHover3 || isActive1 ? 'on' : ''}`}
                                onMouseOver={() => {
                                    setHeaderBtnHover3(true)
                                }}
                                onMouseOut={() => {
                                    setHeaderBtnHover3(false)
                                }}
                                style={{
                                    minWidth: lang === 0 ? '77px' : '',
                                    fontSize: lang === 1 ? '18px' : ''
                                }}
                                onClick={() => {
                                    navigate(routes.Support)
                                }}
                            >
                                {lang === 0 ? '학습 및 지원' : 'Support'}
                            </div>

                            <div
                                className={`header_btn ${headerBtnHover5 || isActive3 ? 'on' : ''}`}
                                onMouseOver={() => {
                                    setHeaderBtnHover5(true)
                                }}
                                onMouseOut={() => {
                                    setHeaderBtnHover5(false)
                                }}
                                style={{
                                    minWidth: lang === 1 ? '85px' : '',
                                    fontSize: lang === 1 ? '18px' : ''
                                }}
                                onClick={() => {
                                    navigate(routes.Education)
                                }}
                            >
                                {lang === 0 ? '학교' : 'School'}
                            </div>

                            <div
                                className={`header_btn ${headerBtnHover4 || isActive2 ? 'on' : ''}`}
                                onMouseOver={() => {
                                    setHeaderBtnHover4(true)
                                }}
                                onMouseOut={() => {
                                    setHeaderBtnHover4(false)
                                }}
                                style={{
                                    minWidth: lang === 1 ? '60px' : '',
                                    fontSize: lang === 1 ? '18px' : ''
                                }}
                                onClick={() => {
                                    navigate(routes.Price)
                                }}
                            >
                                {lang === 0 ? '가격' : 'Pricing'}
                            </div>

                            <div
                                className={`header_btn manual ${headerBtnHover6 || isActive4 ? 'on' : ''}`}
                                onMouseOver={() => {
                                    setHeaderBtnHover6(true)
                                }}
                                onMouseOut={() => {
                                    setHeaderBtnHover6(false)
                                }}
                                style={{
                                    minWidth: lang === 1 ? '127px' : '',
                                    fontSize: lang === 1 ? '18px' : ''
                                }}
                                onClick={() => {
                                    if (lang === 0) {
                                        window.open('https://docs.umodeler.com/ko/docs/intro');
                                    } else {
                                        window.open('https://docs.umodeler.com/docs/intro');
                                    }
                                }}
                            >
                                {lang === 0 ? '공식 매뉴얼' : 'Official Manual'}

                                {headerBtnHover6 || isActive4 ?
                                    <img className="navi" src={require("../assets/icon/navi_icon_on.svg").default} />
                                    :
                                    <img className="navi" src={require("../assets/icon/navi_icon.svg").default} />
                                }
                            </div>
                        </div>
                    </div>
                    <div>
                        
                        <button
                            type="button"
                            className="free_test_btn"
                            onClick={() => {
                                // GA4로 download 이벤트 전송
                                // gtag('event', 'download_hub_header', {
                                //     'event_category': 'engagement',
                                //     'event_label': lang === 0 ? '다운로드 Hub(Header)' : 'Download Hub(Header)'
                                // });

                                const newWindow = window.open('https://bit.ly/3FvWPO8', '_blank');
                                if (newWindow) {
                                    setTimeout(() => {
                                        newWindow.close();
                                    }, 3000000); // 3초 후에 창을 닫습니다. 필요에 따라 시간을 조정하세요.
                                }
                            }}
                        >
                            
                            <span>{lang === 0 ? '다운로드' : 'Download'}</span>

                            <div className="back_color">
                                <span>{lang === 0 ? '다운로드' : 'Download'}</span>
                            </div>
                        </button>

                        <div className="header_login_box pc">
                            
                            {mbData?.idx ?
                                <div
                                    className={`user_profile`}
                                    onMouseOver={() => {
                                        setHeaderProfile(true)
                                    }}
                                    onMouseLeave={() => {
                                        setHeaderProfile(false)
                                    }}
                                >
                                    <img src={require("../assets/icon/Avatar.svg").default} />

                                    {headerProfile &&
                                        <div
                                            className={`profile_drop ${lang === 1 ? 'eng' : ''}`}
                                            onMouseEnter={() => {
                                            }}
                                            onMouseLeave={() => {
                                            }}
                                        >
                                            <p onClick={() => {
                                                navigate(routes.Profile)
                                                setHeaderProfile(false)
                                            }}
                                            >
                                                {lang === 0 ? '프로필' : 'Profile'}
                                            </p>

                                            <p onClick={() => {
                                                navigate(routes.Licensing)
                                                setHeaderProfile(false)
                                            }}
                                            >
                                                {lang === 0 ? '라이선스 관리' : 'Licensing'}
                                            </p>
                                            <p onClick={() => {
                                                navigate(routes.PayList)
                                                setHeaderProfile(false)
                                            }}
                                            >
                                                {lang === 0 ? '결제 내역' : 'Payment History'}
                                            </p>

                                            <p onClick={() => {
                                                navigate(routes.CardList)
                                                setHeaderProfile(false)
                                            }}
                                            >
                                                {lang === 0 ? '카드 관리' : 'Card Management'}
                                            </p>
                                            <p onClick={() => {
                                                logoutPopup()
                                            }}
                                            >
                                                {lang === 0 ? '로그아웃' : 'Logout'}
                                            </p>
                                        </div>
                                    }
                                </div>
                                :
                                <button
                                    type="button"
                                    className="login_btn"
                                    onClick={() => {
                                        navigate(routes.login)
                                    }}
                                >
                                    {lang === 0 ? '로그인' : 'Login'}
                                </button>
                            }

                            {/* <div 
                                className="language_btn"
                                onClick={() => {
                                    setLangDrop(!langDrop)
                                }}
                                style={{
                                    width: lang === 0 ? '72px' : ''
                                }}
                            >
                                <img src={require("../assets/icon/language.svg").default} />
                                {lang === 0 ? '한국어' : 'English'}
                                {langDrop &&
                                    <div className="lang_drop">
                                        <p
                                            className={`${lang === 0 ? 'on' : ''}`}
                                            onClick={() => {
                                                ChangeLang(0)
                                            }}
                                        >
                                            한국어
                                        </p>
                                        <p
                                            className={`${lang === 1 ? 'on' : ''}`}
                                            onClick={() => {
                                                ChangeLang(1)
                                            }}
                                        >
                                            English
                                        </p>
                                    </div>
                                }
                            </div> */}
                        </div>
                    </div>

                    <div className="header_mobile_btn">
                        <img
                            src={require("../assets/icon/3line.svg").default}
                            onClick={() => {
                                if (mobileMenu) {
                                    setMobileMenu(false)
                                    setMobileBtnHover1(false)
                                    setMobileBtnHover2(false)
                                    setMobileBtnHover3(false)
                                    setMobileBtnHover4(false)
                                    setMobileBtnHover5(false)
                                } else {
                                    setMobileMenu(true)
                                }
                            }}
                        />
                    </div>
                </div>

                <div
                    className={`header_mobile_menu_box ${mobileMenu ? 'show' : ''}`}
                >
                    <div className="header_login_box mobile">
                        {mbData?.idx ?
                            <div
                                className="user_profile"
                                onMouseEnter={() => {
                                    setHeaderProfile(true)
                                }}
                                onMouseLeave={() => {
                                    setHeaderProfile(false)
                                }}
                            /* onClick={() => {
                                setHeaderProfile(!headerProfile)
                            }} */
                            >
                                <img src={require("../assets/icon/Avatar.svg").default} />

                                {headerProfile &&
                                    <div className={`profile_drop ${lang === 1 ? 'eng' : ''}`}>
                                        <p onClick={() => {
                                            navigate(routes.Profile)
                                            setHeaderProfile(false)
                                            setMobileMenu(false)
                                        }}
                                        >
                                            {lang === 0 ? '프로필' : 'Profile'}
                                        </p>

                                        <p onClick={() => {
                                            navigate(routes.Licensing)
                                            setHeaderProfile(false)
                                            setMobileMenu(false)
                                        }}
                                        >
                                            {lang === 0 ? '라이선스 관리' : 'Licensing'}
                                        </p>

                                        {/* <p onClick={() => {
                                            navigate(routes.BuyList)
                                            setHeaderProfile(false)
                                            setMobileMenu(false)
                                        }}
                                        >
                                            {lang === 0 ? '구매 내역' : 'Purchase History'}
                                        </p> */}

                                        <p onClick={() => {
                                            navigate(routes.PayList)
                                            setHeaderProfile(false)
                                            setMobileMenu(false)
                                        }}
                                        >
                                            {lang === 0 ? '결제 내역' : 'Payment History'}
                                        </p>

                                        <p onClick={() => {
                                            navigate(routes.CardList)
                                            setHeaderProfile(false)
                                            setMobileMenu(false)
                                        }}
                                        >
                                            {lang === 0 ? '카드 관리' : 'Card Management'}
                                        </p>

                                        {/*  <p onClick={() => {
                                            navigate(routes.InquiryList)
                                            setHeaderProfile(false)
                                            setMobileMenu(false)
                                        }}
                                        >
                                            {lang === 0 ? '문의 내역' : 'Inquiry History'}
                                        </p> */}

                                        <p onClick={() => {
                                            logoutPopup()
                                        }}
                                        >
                                            {lang === 0 ? '로그아웃' : 'Logout'}
                                        </p>
                                    </div>
                                }
                            </div>
                            :
                            <button
                                type="button"
                                className="login_btn"
                                onClick={() => {
                                    navigate(routes.login)
                                }}
                            >
                                {lang === 0 ? '로그인' : 'Login'}
                            </button>
                        }

                        {/* <div 
                            className="language_btn"
                            onClick={() => {
                                setLangDrop(!langDrop)
                            }}
                            style={{
                                width: lang === 0 ? '72px' : ''
                            }}
                        >
                            <img src={require("../assets/icon/language.svg").default} />
                            {lang === 0 ? '한국어' : 'English'}
                            {langDrop &&
                                <div className="lang_drop">
                                    <p
                                        className={`${lang === 0 ? 'on' : ''}`}
                                        onClick={() => {
                                            ChangeLang(0)
                                        }}
                                    >
                                        한국어
                                    </p>
                                    <p
                                        className={`${lang === 1 ? 'on' : ''}`}
                                        onClick={() => {
                                            ChangeLang(1)
                                        }}
                                    >
                                        English
                                    </p>
                                </div>
                            }
                        </div> */}
                    </div>

                    <div
                        className={`header_mobile_menu_list ${mobileBtnHover1 ? 'on' : ''}`}
                        onClick={() => {
                            if (mobileBtnHover1) {
                                setMobileBtnHover1(false)
                            } else {
                                setMobileBtnHover2(false)
                                setMobileBtnHover3(false)
                                setMobileBtnHover4(false)
                                setMobileBtnHover5(false)
                                setMobileBtnHover1(true)
                            }
                        }}
                        style={{
                            marginBottom: '-12px'
                        }}

                    >
                        <p>
                            {lang === 0 ? '기능' : 'Features'}
                            {mobileBtnHover1 ?
                                <img src={require("../assets/icon/down_arr_on.svg").default} />
                                :
                                <img src={require("../assets/icon/down_arr_off.svg").default} />
                            }
                        </p>

                        <div
                            className={`header_mobile_menu_list_sub ${mobileBtnHover1 ? 'show' : ''}`}
                        >
                            <p
                                className=""
                                onClick={() => {
                                    navigate(routes.Modeling);
                                    setMobileMenu(false);
                                }}
                            >
                                {lang === 0 ? '모델링' : 'Modeling'}
                            </p>
                            <p
                                className=""
                                onClick={() => {
                                    navigate(routes.UV_Editing)
                                    setMobileMenu(false);
                                }}
                            >
                                {lang === 0 ? 'UV 에디팅' : 'UV Editing'}
                            </p>
                            <p
                                className=""
                                onClick={() => {
                                    navigate(routes.Painting)
                                    setMobileMenu(false);
                                }}
                            >
                                {lang === 0 ? '페인팅' : 'Painting'}
                            </p>
                            <p
                                className=""
                                onClick={() => {
                                    navigate(routes.Rigging)
                                    setMobileMenu(false);
                                }}
                            >
                                {lang === 0 ? '리깅과 스키닝' : 'Rigging and Skinning'}
                            </p>
                            <p
                                className=""
                                onClick={() => {
                                    navigate(routes.Intergration)
                                    setMobileMenu(false);
                                }}
                            >
                                {lang === 0 ? '유니티 통합환경' : 'Unity Intergration'}
                            </p>
                            <p
                                className=""
                                onClick={() => {
                                    navigate(routes.Extension)
                                    setMobileMenu(false);
                                }}
                            >
                                {lang === 0 ? 'Pro 확장 기능' : 'Pro Extension Features'}
                            </p>
                            <p
                                className=""
                                onClick={() => {
                                    navigate(routes.AI)
                                    setMobileMenu(false);
                                }}
                            >
                                {lang === 0 ? '생성형 AI 활용' : 'Generative AI Utilization'}
                            </p>
                            <p
                                className=""
                                onClick={() => {
                                    navigate(routes.Library)
                                    setMobileMenu(false);
                                }}
                            >
                                {lang === 0 ? '템플릿 라이브러리' : 'Template Library'}
                            </p>
                        </div>
                    </div>

                    <div
                        className={`header_mobile_menu_list ${mobileBtnHover2 ? 'on' : ''}`}
                        onClick={() => {
                            if (mobileBtnHover2) {
                                setMobileBtnHover2(false)
                            } else {
                                setMobileBtnHover1(false)
                                setMobileBtnHover3(false)
                                setMobileBtnHover4(false)
                                setMobileBtnHover5(false)
                                setMobileBtnHover2(true)
                            }
                        }}
                        style={{
                            marginBottom: '-12px'
                        }}

                    >
                        <p>
                            {lang === 0 ? '활용 분야' : 'Use Cases'}
                            {mobileBtnHover2 ?
                                <img src={require("../assets/icon/down_arr_on.svg").default} />
                                :
                                <img src={require("../assets/icon/down_arr_off.svg").default} />
                            }
                        </p>

                        <div
                            className={`header_mobile_menu_list_sub ${mobileBtnHover2 ? 'show' : ''}`}
                        >
                            <p
                                className=""
                                onClick={() => {
                                    setMobileMenu(false);
                                    navigate(routes.GameDev);
                                }}
                            >
                                {lang === 0 ? '게임 개발' : 'Game Development'}
                            </p>
                            <p
                                className=""
                                onClick={() => {
                                    setMobileMenu(false);
                                    navigate(routes.Metaverse);
                                }}
                            >
                                {lang === 0 ? '메타버스 제작' : 'Metaverse Creation'}
                            </p>
                            {/* <p 
                                className=""
                                onClick={() => {
                                    setMobileMenu(false);
                                    navigate(routes.Indust);
                                }}
                            >
                                {lang === 0 ? '산업 디자인' : 'Industrial Design'}
                            </p> */}
                            <p
                                className=""
                                onClick={() => {
                                    setMobileMenu(false);
                                    navigate(routes.Edu);
                                }}
                            >
                                {lang === 0 ? '교육' : 'Education'}
                            </p>
                        </div>
                    </div>

                    <div
                        className={`header_mobile_menu_list ${mobileBtnHover3 ? 'on' : ''}`}
                        onClick={() => {
                            if (mobileBtnHover3) {
                                setMobileBtnHover3(false)
                            } else {
                                setMobileBtnHover1(false)
                                setMobileBtnHover2(false)
                                setMobileBtnHover4(false)
                                setMobileBtnHover5(false)
                                setMobileBtnHover3(true)
                            }
                        }}
                        style={{
                            marginBottom: '12px'
                        }}
                    >
                        <p
                            onClick={() => {
                                setMobileMenu(false)
                                navigate(routes.Support)
                            }}
                        >
                            {lang === 0 ? '학습 및 지원' : 'Support'}
                        </p>
                    </div>

                    <div
                        className={`header_mobile_menu_list ${mobileBtnHover5 ? 'on' : ''}`}
                        onClick={() => {
                            if (mobileBtnHover5) {
                                setMobileBtnHover5(false)
                            } else {
                                setMobileBtnHover1(false)
                                setMobileBtnHover2(false)
                                setMobileBtnHover3(false)
                                setMobileBtnHover4(false)
                                setMobileBtnHover5(true)
                            }
                        }}
                        style={{
                            marginBottom: '12px'
                        }}
                    >
                        <p
                            onClick={() => {
                                setMobileMenu(false)
                                navigate(routes.Education)
                            }}
                        >
                            {lang === 0 ? '학교' : 'School'}
                        </p>
                    </div>

                    <div
                        className={`header_mobile_menu_list ${mobileBtnHover4 ? 'on' : ''}`}
                        onClick={() => {
                            if (mobileBtnHover4) {
                                setMobileBtnHover4(false)
                            } else {
                                setMobileBtnHover1(false)
                                setMobileBtnHover2(false)
                                setMobileBtnHover3(false)
                                setMobileBtnHover5(false)
                                setMobileBtnHover4(true)
                            }
                        }}
                        style={{
                            marginBottom: '12px'
                        }}
                    >
                        <p
                            onClick={() => {
                                setMobileMenu(false)
                                navigate(routes.Price)
                            }}

                        >
                            {lang === 0 ? '가격' : 'Pricing'}
                        </p>
                    </div>

                    <div
                        className={`header_mobile_menu_list ${mobileBtnHover6 ? 'on' : ''}`}
                        onClick={() => {
                            if (mobileBtnHover6) {
                                setMobileBtnHover6(false)
                            } else {
                                setMobileBtnHover1(false)
                                setMobileBtnHover2(false)
                                setMobileBtnHover3(false)
                                setMobileBtnHover4(false)
                                setMobileBtnHover5(false)
                                setMobileBtnHover6(true)
                            }
                        }}
                    >
                        <p
                            onClick={() => {
                                setMobileMenu(false)
                                if (lang === 0) {
                                    window.open('https://docs.umodeler.com/ko/docs/intro');
                                } else {
                                    window.open('https://docs.umodeler.com/docs/intro');
                                }
                            }}
                        >
                            {lang === 0 ? '공식 매뉴얼' : 'Official Manual'}
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

